var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-dialog",
    {
      attrs: { "max-width": "950" },
      scopedSlots: _vm._u([
        {
          key: "activator",
          fn: function (ref) {
            var on = ref.on
            var attrs = ref.attrs
            return [
              _vm.mobile
                ? [
                    _c(
                      "button",
                      _vm._g(
                        _vm._b(
                          {
                            staticClass: "btn rounded-pill bg-dark text-white",
                            attrs: { type: "button" },
                          },
                          "button",
                          attrs,
                          false
                        ),
                        on
                      ),
                      [_vm._v("\n        質問を作成する\n      ")]
                    ),
                  ]
                : [
                    _c(
                      "v-btn",
                      _vm._g(
                        _vm._b(
                          {
                            attrs: {
                              fab: "",
                              dark: "",
                              small: "",
                              color: "teal",
                            },
                          },
                          "v-btn",
                          attrs,
                          false
                        ),
                        on
                      ),
                      [
                        _c("v-icon", { attrs: { dark: "" } }, [
                          _vm._v("mdi-plus"),
                        ]),
                      ],
                      1
                    ),
                  ],
            ]
          },
        },
      ]),
      model: {
        value: _vm.dialog,
        callback: function ($$v) {
          _vm.dialog = $$v
        },
        expression: "dialog",
      },
    },
    [
      _vm._v(" "),
      _c("UserQuestionFormView", {
        attrs: { courseId: _vm.courseId, lessonId: _vm.lessonId },
        model: {
          value: _vm.dialog,
          callback: function ($$v) {
            _vm.dialog = $$v
          },
          expression: "dialog",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }